"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Wind, Gauge, Zap, Activity, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
const services = [{
  title: "ליווי סיעודי אישי 24/7",
  description: <>
        השגחה צמודה של <Link to="#" className="text-primary hover:underline font-medium">מטפל סיעודי בבית</Link> מוסמך ומיומן המעניק ביטחון מלא ושקט נפשי למטופל ולבני המשפחה בכל שעות היממה.
      </>,
  icon: Activity
}, {
  title: "סיוע רפואי מקצועי",
  description: "מעקב אחר מדדים רפואיים, ניהול תרופות ותיאום מול גורמים רפואיים להבטחת רצף טיפולי מיטבי ומקצועי.",
  icon: ShieldCheck
}, {
  title: "עזרה בפעולות היומיום",
  description: "תמיכה מלאה ברחצה, הלבשה, ניידות ותזונה, תוך שמירה מרבית על כבודו, פרטיותו ועצמאותו של המטופל.",
  icon: Wind
}, {
  title: "ליווי וייעוץ למשפחה",
  description: "הכוונה מקצועית וליווי רגשי לבני המשפחה לאורך כל שלבי הטיפול, כולל סיוע במיצוי זכויות מול המוסדות השונים.",
  icon: Gauge
}, {
  title: "השגחה לאחר אשפוז",
  description: <>
        שיקום ביתי וליווי צמוד לאחר ניתוח או <Link to="/" className="text-primary hover:underline font-medium">השגחה בבית חולים</Link>, במטרה להחזיר את המטופל לשגרת חייו במהירות ובבטחה.
      </>,
  icon: Zap
}];
export default function OurServices() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3337" id="service-details" className="bg-background py-24 relative overflow-hidden">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float-y {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
          }
          .animate-float-y {
            animation: float-y 6s ease-in-out infinite;
          }
        `
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-6">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 font-default">
                שירותי סיעוד מתקדמים ומותאמים אישית
              </h2>
              <p className="text-muted-foreground text-lg max-w-2xl font-default">
                אנו מספקים מעטפת שירותי <Link to="/" className="text-primary hover:underline font-medium">מטפל סיעודי</Link> מקצועית המשלבת טיפול מסור, <Link to="#" className="text-primary hover:underline font-medium">מטפל סיעודי ב[שם העיר]</Link> וניסיון רב שנים. השירות כולל <Link to="#" className="text-primary hover:underline font-medium">מטפל סיעודי בבית</Link> וכן <Link to="/CaregiverServicePagesPage2" className="text-primary hover:underline font-medium">השגחה בבית חולים</Link> להבטחת <Link to="/" className="text-primary hover:underline font-medium">פתרון מיידי</Link> ואיכות חיים מקסימלית למטופלים שלנו.
              </p>
            </div>

            {services.map((service, i) => <div key={i} data-index={i}>
                <div className="block group h-full">
                  <Card className={cn("h-full transition-all duration-300 ease-out", "bg-muted/30", "border border-border", "rounded-xl overflow-hidden", "hover:scale-[1.02] hover:shadow-lg hover:bg-card")}>
                    <div className="flex flex-col sm:flex-row items-start p-6 sm:p-8 gap-6">
                      {}
                      <div className="shrink-0">
                        <div className="relative flex items-center justify-center size-14 rounded-xl bg-card border border-border shadow-sm group-hover:border-ring/30 transition-colors duration-300">
                          <service.icon className={cn("size-8 transition-colors duration-300", "text-ring", "fill-primary/10", "group-hover:text-chart-2", "group-hover:fill-chart-2/10")} strokeWidth={2} />
                        </div>
                      </div>

                      {}
                      <div className="space-y-2">
                        <h3 className="text-[1.5rem] font-bold text-primary font-default leading-tight group-hover:text-ring transition-colors duration-300">
                          {service.title}
                        </h3>
                        <div className="text-muted-foreground leading-relaxed font-default">
                          {service.description}
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>)}
          </div>

          {}
          <div className="lg:col-span-5 lg:sticky lg:top-24 hidden lg:block pt-12">
            <div className="relative rounded-2xl bg-muted/30 border border-border animate-float-y transition-shadow duration-100 ease-linear" style={{
            boxShadow: `0px ${20 + scrollY * 0.03}px ${40 + scrollY * 0.06}px -10px rgba(30, 41, 59, ${Math.min(0.3, 0.1 + scrollY * 0.0005)})`
          }}>
              <div className="relative overflow-hidden rounded-2xl aspect-[4/5]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_support.png" alt="צוות סיעודי מקצועי ומסור" className="w-full h-full object-cover" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/20 rounded-2xl pointer-events-none" />
              </div>
            </div>

            {}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[100%] bg-ring/5 blur-3xl rounded-full pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}